import Pochta from "./Pochta";
function ESFP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper">
          <img src="/img/Развлекатель ESFP.png" className="ESFP"/>
          </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ESFP</h2>
  <p><strong>Процент населения:</strong> 10–12%</p>
<p><strong>Среди мужчин:</strong> 6–8%</p>
<p><strong>Среди женщин:</strong> 14–17%</p>
<p><strong>Стратегия:</strong> Забота и взаимодействие</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ESFJ черпают энергию из общения и помощи другим. 
  Им нужно быть рядом с людьми, заботиться и поддерживать. 
  Они восстанавливают силы, видя счастье и благодарность окружающих.
</p>
<p>
  Решения ESFJ принимают на основе чувств и личного опыта. 
  Они доверяют своей интуиции в общении и ценят гармонию. 
  Они ценят традиции, стабильность и возможность помогать.
</p>
<p>
  Это тёплые и заботливые люди. 
  Они всегда помнят о других и создают уют вокруг себя. 
  Им трудно принимать критику, но их доброта делает мир лучше.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ESFJ слишком зависят от мнения других. Если их не хвалят — они страдают. 
  Они могут быть навязчивыми и не понимать, что кому-то нужно личное пространство. 
  Их привычка всё контролировать и заботиться иногда переходит границы.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ESFP;